// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewModal_wrapper__3481j","footer":"ViewModal_footer__2Zisb"};